import React, { useState } from "react";
import axios from "axios";

import Loader from "../components/Loader";
import Error from "../components/Error";
import Success from "../components/Success";
import GoogleLoginButton from "../components/GoogleLoginButton";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { useHistory } from "react-router-dom";
import Swal from 'sweetalert2';

function RegisterScreen() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [cpassword, setCpassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const history = useHistory();

  // Email validation
  const validateEmail = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError("Invalid email address");
    } else {
      setError("");
    }
  };

  // Name validation
  const validateName = () => {
    if (name.trim() === "") {
      setError("Name is required");
    } else {
      setError("");
    }
  };

  // Password strength validation
  const validatePassword = () => {
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    if (!passwordRegex.test(password)) {
      setError("Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character");
    } else {
      setError("");
    }
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    validateEmail();
  };

  const handleNameChange = (e) => {
    setName(e.target.value);
    validateName();
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    validatePassword();
  };

  const handleCPasswordChange = (e) => {
    setCpassword(e.target.value);
  };

  // const toggleShowPassword = () => {
  //   setShowPassword(!showPassword);
  // };
  
  async function register() {
    if (password === cpassword) {
      const user = {
        name,
        email,
        password,
        cpassword,
      };
      setLoading(true);
      setError("");
      setSuccess("");
      try {
        const result = (await axios.post("/api/users/register", user)).data;
        console.log(result);
        setSuccess(result);
        setName("");
        setEmail("");
        setPassword("");
        setCpassword("");
        Swal.fire({
        icon: 'success',
        title: 'Registered Successfully',
        text: 'You have been registered successfully!',
      });
        history.push("/login");
      } catch (error) {
        console.log(error);
        setError("Registration failed. Please try again.");
      }
      setLoading(false);
    } else {
      setError("Password confirmation does not match");
    }
  }

  return (
    <div>
      {loading && <Loader></Loader>}
      {error.length > 0 && <Error msg={error}></Error>}

      <div className="row justify-content-center mt-5">
        <div className="col-md-5 mt-5">
          {success.length > 0 && <Success msg={success}></Success>}
          <div className="bs">
            <h2>Register</h2>
            <input
              type="text"
              className="form-control"
              placeholder="Name"
              value={name}
              onChange={handleNameChange}
              onBlur={validateName}
            />
            <input
              type="text"
              className="form-control"
              placeholder="Email"
              value={email}
              onChange={handleEmailChange}
              onBlur={validateEmail}
            />
            <input
              type={showPassword ? "text" : "password"} // Use showPassword state variable
              className="form-control"
              placeholder="Password"
              value={password}
              onChange={handlePasswordChange}
              onBlur={validatePassword}
            />
            <input
              type="password"
              className="form-control"
              placeholder="Confirm Password"
              value={cpassword}
              onChange={handleCPasswordChange}
            />
            {/* <span onClick={toggleShowPassword} className="show-password">
              {showPassword ? "Hide" : "Show"} Password
            </span> */}
            {loading ? (
              <div>Registering... Please Wait...</div>
            ) : (
              <button className="btn btn-primary mt-3" onClick={register}>
                Register
              </button>
            )}
            <div className="GoogleSigninButton"  style={{display: 'flex', justifyContent: 'center', marginTop: '10px'}}>
              <GoogleOAuthProvider clientId="217188716056-06qj11ckgmbc7msoecdm17po16td4d71.apps.googleusercontent.com">
                <GoogleLoginButton />
              </GoogleOAuthProvider>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RegisterScreen;
